import { useUserOrganization } from '@modules-deprecated/app/organization'

import { LabsFlag } from '../enums/labsFlag'
import { useLabsMenuFlags } from './useLabsMenuFlags'

export const useIsExpertReportEnabled = (flag: LabsFlag): boolean => {
  const { organization } = useUserOrganization()
  const labsFlags = useLabsMenuFlags()

  return organization?.countryId === 'FR' && labsFlags[LabsFlag.Reports] && labsFlags[flag]
}
